/* Code written to mark all external outbound link as no follow*/
document.querySelectorAll('a[href^="http"]').forEach(function(link) {
  if (link.hostname !== window.location.hostname) {
    link.setAttribute('rel', 'nofollow noopener noreferrer');
  }
});